import { forwardRef } from 'react';
// material
import { alpha, useTheme } from '@mui/material/styles';
import { Checkbox } from '@mui/material';
import type { CheckboxProps } from '@mui/material';

// ----------------------------------------------------------------------

type MCheckboxProps = Omit<CheckboxProps, 'color'> & { color?: string };

const MCheckbox = forwardRef<HTMLButtonElement, MCheckboxProps>(
  function MCheckboxImpl({ color = 'primary', sx, ...other }, ref) {
    const theme = useTheme();
    const palette = theme.palette as typeof theme.palette & Record<string, any>;

    if (color === 'default' || color === 'primary' || color === 'secondary') {
      return <Checkbox ref={ref} color={color} sx={sx} {...other} />;
    }

    return (
      <Checkbox
        ref={ref}
        sx={{
          '&.Mui-checked': {
            color: palette[color].main,
          },
          '&.MuiCheckbox-indeterminate': {
            color: palette[color].main,
          },
          '&:hover, &.Mui-checked:hover': {
            backgroundColor: alpha(
              palette[color].main,
              theme.palette.action.hoverOpacity
            ),
          },
          ...sx,
        }}
        {...other}
      />
    );
  }
);

export default MCheckbox;
